<template>
  <div class="container">
    <p class="label" v-safe-html="label" />
    <p class="description" v-if="description" v-safe-html="description" />
    <p class="title" v-if="title" v-safe-html="title" />
    <p class="detail" v-safe-html="detail" />
  </div>
</template>

<script>
export default {
  name: "OfferElement",
  props: {
    label: String,
    description: String,
    noBullet: {
      type: Boolean,
      default: false
    },
    detail: String,
    detailModal: String,
    labelLight: [Boolean, String],
    customLink: String,
    customLinkText: String,
    title: String
  }
};
</script>
